import { SortField, SortOrder, SortType } from '../types/endpoints';

export const DEFAULT_SORTING_OPTION = SortType.PriceLowHigh;

type SortOption = {
  label: string;
  key: string;
  value: {
    sortOrder: SortOrder;
    sortField: SortField;
  };
};

export const sortingOptions: SortOption[] = [
  {
    label: 'Best Deals',
    key: SortType.BestDeal,
    value: {
      sortOrder: null,
      sortField: SortField.BestDeal,
    },
  },
  {
    label: 'Ending Soonest',
    key: SortType.EndingSoonest,
    value: {
      sortOrder: SortOrder.Asc,
      sortField: SortField.EndTime,
    },
  },
  {
    label: 'Newest',
    key: SortType.Newest,
    value: {
      sortOrder: SortOrder.Desc,
      sortField: SortField.Created,
    },
  },
  {
    label: 'Payment High - Low',
    key: SortType.PriceHighLow,
    value: {
      sortOrder: SortOrder.Desc,
      sortField: SortField.Payment,
    },
  },
  {
    label: 'Payment Low - High',
    key: SortType.PriceLowHigh,
    value: {
      sortOrder: SortOrder.Asc,
      sortField: SortField.Payment,
    },
  },
  {
    label: 'Recently Completed',
    key: SortType.Completed,
    value: {
      sortOrder: SortOrder.Desc,
      sortField: SortField.EndTime,
    },
  },
  {
    label: 'None',
    key: SortType.ExactMatch,
    value: {
      sortOrder: SortOrder.Asc,
      sortField: SortField.ID,
    },
  },
  {
    label: 'None',
    key: SortType.Random,
    value: {
      sortOrder: SortOrder.Asc,
      sortField: SortField.Random,
    },
  },
  {
    label: 'None',
    key: SortType.PopularModel,
    value: {
      sortOrder: SortOrder.Desc,
      sortField: SortField.PopularModel,
    },
  },
];

export const activeSortingOptions: SortOption[] = [
  SortType.BestDeal,
  SortType.EndingSoonest,
  SortType.Newest,
  SortType.PriceHighLow,
  SortType.PriceLowHigh,
].map((key) => sortingOptions.find((option) => option.key === key));

export const completedSortingOptions: SortOption[] = [
  SortType.Completed,
  SortType.PriceHighLow,
  SortType.PriceLowHigh,
].map((key) => sortingOptions.find((option) => option.key === key));

export const getDefaultSortingOption = () =>
  sortingOptions.find((option) => option.key === DEFAULT_SORTING_OPTION);
